// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--BBLVZ","inner":"a10a3f92e9--inner--oRb6x","title":"a10a3f92e9--title--MqtWm","description":"a10a3f92e9--description--Utezu"};